import React, {useState} from 'react';
import 'swiper/swiper.css';
import 'swiper/modules/navigation/navigation.scss';
import {
	expressInterestInLocation,
	handleApiResponse,
	logJsError,
} from '../../services/api.service';
import {
	getFromStore,
	saveToStore,
	StorePath,
	storeSaveAction,
	useStoreActionsFromStore,
} from '../../services/store.service';
import MessageModel from '../../models/message.model';
import {addLatestMessage} from '../../services/message.service';

const Locations = ({data}: {data: string[]}) => {
	const storeAction = useStoreActionsFromStore(storeSaveAction);
	const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];
	const [selectedLocation, setSelectedLocation] = useState('');

	const handleLocationSelection = (location: string): void => {
		setSelectedLocation(location);
		const typingTimeout = setTimeout(() => {
			saveToStore(storeAction, StorePath.AGENT_TYPING, true);
		}, 1300);

		expressInterestInLocation(location)
			.then(handleApiResponse)
			.then((data: any) => {
				addLatestMessage(data.messages, messages, storeAction);
				saveToStore(storeAction, StorePath.AGENT_TYPING, false);
				clearTimeout(typingTimeout);
			})
			.catch((error) => {
				logJsError(error);
			});
	};

	const isSelected = (location: string): boolean => {
		return selectedLocation === location;
	};

	return (
		<div className={'flex flex-col items-start'}>
			{data.map((location: string) => (
				<button key={location} className={`my-1 ml-10 p-2 rounded-sm border cursor-pointer ${isSelected(location) ? 'bg-primary text-white' : ''}`}
				     onClick={() => handleLocationSelection(location)}>
					<span className="whitespace-pre-line" style={{wordBreak: 'break-word'}}>
						 {location}
					</span>
				</button>
			))}
		</div>
	);
};

export default Locations;
